import { ICards } from '@interfaces/home/ICards'
import INewUser from '@interfaces/home/INewUser'
import IShareData from '@interfaces/home/IShareData'
import api from '@services/api/server'

export default class DashboardService {
    public static async getCards(): Promise<ICards> {
        return (await api.get<ICards>('/dashboard/cards-data')).data
    }

    public static async getShareData(): Promise<IShareData[]> {
        return (await api.get<IShareData[]>('/dashboard/last-30-days-sharing-report')).data
    }

    public static async getNewCustomers(): Promise<INewUser[]> {
        return (await api.get<INewUser[]>('/dashboard/last-30-days-new-customers-report')).data
    }

    public static async getNewRealtors(): Promise<INewUser[]> {
        return (await api.get<INewUser[]>('/dashboard/last-30-days-new-realtors-report')).data
    }
}
